import DetailsLayout from 'components/SharedLayout/DetailsLayout/detailsLayout';
import TableLayout from 'components/SharedLayout/TableLayout/tableLayout';
import EuTableLayout from 'pages/EuTableLayout/euTableLayout';
import React, { useState, useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import MultiSelect from 'components/SharedLayout/Multiselect/multiSelect';
import InlineMessage from '@ingka/inline-message';
interface EuSubmitRegisteryProps {
  queries: string;
  setQuery: (query: string) => void;
  tabChange: (tab: any) => void;
  items: any[];
  handleTabChange: (tabChange: string) => void;
  setActiveTab: (tabId: string) => void;
  setSelectedStatus: (status: string) => void;
  setSupplierDDSRefNum: (ref: string) => void;
  setFedsa_RefNum: (ref: string) => void;
  fedsa_RefNum?: string | null;
  selectedStatus?: string;
}

const EuSubmitRegistery: FC<EuSubmitRegisteryProps> = ({
  queries,
  setQuery,
  tabChange,
  items,
  handleTabChange,
  setActiveTab,
  setSelectedStatus,
  setSupplierDDSRefNum,
  setFedsa_RefNum,
  selectedStatus,
  fedsa_RefNum,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { euSubmittedToEuList } = useSelector((state: RootState) => state.euSubmittedToEuList);

  const [SubmitListData, setSubmitListData] = useState<any>([]);
  const [multiSelectKey, setMultiSelectKey] = useState(0);
  const [noResponse, setNoResponse] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState<string[]>([]);
  const [pdfInlineMessage, setPDFInlineMessage] = useState('');
  const [previousStatus, setPreviousStatus] = useState('');

  const mapping = {
    // isEntryFromAPI: 'Source',
    supplierName: 'Supplier Name',
    fedsa_dds_RefNum: 'DDS Reference Number',
    article_number: 'Supplier Article Number',
    m3_article_id: 'm3 Article Number',
    gtin: 'GTIN',
    // goodsDescription: 'Trade Item Description',
    submittedOn: 'Date of Submission',
    fedsaStatus: 'Current status',
    retailerPublishStatus: 'Retailer publish status',
    activityType: 'Activity Type',
    fedsa_RefNum: 'Ref_Num',
    pdf: 'PDF',
    link: 'Link to Parent DDS',
  };
  useEffect(() => {
    if (fedsa_RefNum && selectedStatus === 'IKEA') {
      setQuery(fedsa_RefNum);
      onSearch(fedsa_RefNum);
      setHasSearched(true);
    }
  }, [fedsa_RefNum, selectedStatus]);

  useEffect(() => {
    if (selectedStatus !== 'IKEA') {
      setFedsa_RefNum('');
      setQuery('');
      setHasSearched(false);
      setFilteredData([]);
      setSubmitListData([]);
      setNoResponse(false);
    }
  }, [selectedStatus]);

  useEffect(() => {
    const items = mappedItems(euSubmittedToEuList, mapping);

    if (!queries || queries.trim().length === 0) {
      setSubmitListData(items);
      setFilteredData(items);

      if (!hasSearched) {
        setNoResponse(false);
      }

      setHasSearched(false);
    } else {
      const trimmedQuery = queries.trim().toLowerCase();
      const filteredItems = items.filter(
        (item) =>
          item['Supplier Name']?.toLowerCase().includes(trimmedQuery) ||
          item['Supplier Articles Number']?.toLowerCase().includes(trimmedQuery) ||
          item['GTIN']?.toLowerCase().includes(trimmedQuery) ||
          item['DDS Reference Number']?.toLowerCase() === trimmedQuery ||
          item['__fullRefNum']?.toLowerCase().includes(trimmedQuery) ||
          item['m3 Article Number']?.toLowerCase().includes(trimmedQuery)
      );

      setSubmitListData(filteredItems);
      setFilteredData(filteredItems);
      setNoResponse(filteredItems?.length === 0);
      setHasSearched(true);
    }
  }, [euSubmittedToEuList, queries]);

  useEffect(() => {
    setMultiSelectKey((prevKey) => prevKey + 1);
  }, [tabChange]);

  const mappedItems = (itemList, mappingKey) => {
    if (!Array.isArray(itemList)) return [];

    return itemList.map((item) => {
      return Object.keys(mappingKey).reduce((acc, key) => {
        if (key === 'fedsa_RefNum' && item[key]) {
          acc[mappingKey[key]] = item[key].toString().slice(0, 5) + '...';
          acc['__fullRefNum'] = item[key];
        } else {
          acc[mappingKey[key]] = item[key] !== undefined ? item[key] : null;
        }
        return acc;
      }, {});
    });
  };

  const onSearch = (searchQuery) => {
    if (searchQuery === '' && queries === '') return;
    setQuery(searchQuery);
    setHasSearched(true);
  };

  const getFilterData = (data) => {
    const uniqueNames = Array?.from(
      new Set(
        data?.map((item: { [x: string]: any }) => item['supplierName']).filter((name: any) => name)
      )
    );

    return uniqueNames;
  };

  const comboFilter = (list) => {
    setSelectedSuppliers(list);
  };

  return (
    <div className="details-container">
      <div className="table-container">
        <div style={{ paddingTop: '8px' }}>
          <div style={{ width: '25%' }}>
            <MultiSelect
              key={multiSelectKey}
              item={getFilterData(euSubmittedToEuList)}
              comboFilter={comboFilter}
              tabChange={tabChange}
            />
          </div>
          {euSubmittedToEuList?.length === 0 ? (
            <div className="no-response">
              <p>No data available</p>
            </div>
          ) : SubmitListData?.length > 0 ? (
            <EuTableLayout
              items={SubmitListData}
              isLeftSide={true}
              euPendingApprovalData={euSubmittedToEuList}
              onSearch={onSearch}
              tabChange={tabChange}
              handleTabChange={handleTabChange}
              setActiveTab={setActiveTab}
              setSupplierDDSRefNum={setSupplierDDSRefNum}
              setSelectedStatus={setSelectedStatus}
              setHasSearched={setHasSearched}
              pdfInlineMessage={pdfInlineMessage}
              setPDFInlineMessage={setPDFInlineMessage}
              selectedStatus={selectedStatus}
            />
          ) : hasSearched && noResponse ? (
            <div className="no-response">
              <p>0 results found</p>
            </div>
          ) : null}
        </div>
      </div>
      {pdfInlineMessage && (
        <InlineMessage
          body={pdfInlineMessage}
          link=""
          linkLabel=""
          title="Notification"
          variant="negative"
          dismissable
        />
      )}
    </div>
  );
};

export default EuSubmitRegistery;
